<template>
  <div id="container">
    <div class="title">
      <div class="titleTxt">飞行活动运行图</div>
    </div>
    <div class="content">
      <!-- <div class="title">
          <div class="titleTxt">飞行活动运行图</div>
      </div> -->
      <div class="chart-container">
        <!-- echarts图 -->
        <div ref="chart" class="echarts-chart"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import {treemapSquarify} from 'd3';
import echarts from 'echarts';

export default {
  data() {
    return {
      chart: null,
      taskPlanCompletedList: [],
      itemCompletedList: [],
      startTime: [],
      endTime: [],
      startPoint: [],
      endPoint: [],
      airpointList: [],
      altitude: [],
      line1: [],
      line2: [],
      line3: [],
      lineData: [
        [{value: 0, symbol: 'circle'}, {value: 7.14, symbol: 'none'},
          {value: 14.28, symbol: 'none'}, {value: 21.42, symbol: 'none'},
          {value: 28.56, symbol: 'none'}, {value: 35.7, symbol: 'none'},
          {value: 42.84, symbol: 'none'}, {value: 49.98, symbol: 'none'},
          {value: 57.12, symbol: 'none'}, {value: 64.26, symbol: 'none'},
          {value: 71.4, symbol: 'none'}, {value: 78.54, symbol: 'none'},
          {value: 85.68, symbol: 'none'}, {value: 92.82, symbol: 'none'}, {value: 100, symbol: 'circle'}],
        [
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},

          {value: 0, symbol: 'circle'}, {value: 5.88, symbol: 'none'},
          {value: 11.76, symbol: 'none'}, {value: 17.64, symbol: 'none'},
          {value: 23.52, symbol: 'none'}, {value: 29.40, symbol: 'none'},
          {value: 35.28, symbol: 'none'}, {value: 41.16, symbol: 'none'},
          {value: 47.04, symbol: 'none'}, {value: 52.92, symbol: 'none'},
          {value: 58.80, symbol: 'none'}, {value: 64.68, symbol: 'none'},
          {value: 70.56, symbol: 'none'}, {value: 76.44, symbol: 'none'},
          {value: 82.32, symbol: 'none'}, {value: 88.20, symbol: 'none'},
          {value: 94.08, symbol: 'none'}, {value: 100, symbol: 'circle'}
        ],
        [
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},

          {value: 0, symbol: 'circle'}, {value: 6.67, symbol: 'none'},
          {value: 13.33, symbol: 'none'}, {value: 20, symbol: 'none'},
          {value: 26.67, symbol: 'none'}, {value: 33.33, symbol: 'none'},
          {value: 40, symbol: 'none'}, {value: 46.67, symbol: 'none'},
          {value: 53.33, symbol: 'none'}, {value: 60, symbol: 'none'},
          {value: 66.67, symbol: 'none'}, {value: 73.33, symbol: 'none'},
          {value: 80, symbol: 'none'}, {value: 86.67, symbol: 'none'},
          {value: 93.33, symbol: 'none'}, {value: 100, symbol: 'circle'}
        ],
        [
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},
          {value: null, symbol: 'none'},

          {value: 0, symbol: 'circle'}, {value: 6.67, symbol: 'none'},
          {value: 13.33, symbol: 'none'}, {value: 20, symbol: 'none'},
          {value: 26.67, symbol: 'none'}, {value: 33.33, symbol: 'none'},
          {value: 40, symbol: 'none'}, {value: 46.67, symbol: 'none'},
          {value: 53.33, symbol: 'none'}, {value: 60, symbol: 'none'},
          {value: 66.67, symbol: 'none'}, {value: 73.33, symbol: 'none'},
          {value: 80, symbol: 'none'}, {value: 86.67, symbol: 'none'},
          {value: 93.33, symbol: 'none'}, {value: 100, symbol: 'circle'}
          // { value: 0, symbol: 'circle' },{ value: 10, symbol: 'none' },
          // { value: 20, symbol: 'none' },{ value: 30, symbol: 'none' },
          // { value: 40, symbol: 'none' },{ value: 50, symbol: 'none' },
          // { value: 60, symbol: 'none' },{ value: 70, symbol: 'none' },
          // { value: 80, symbol: 'none' },{ value: 90, symbol: 'none' },
          // { value: 100, symbol: 'circle' }
        ]
      ],
      markPointData: [
        [
          {
            coord: ['9:30', 2],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '智汇园8号楼起降点2',
              rotate: 50,
              color: '#56f98d',
            },
          },
          {
            coord: ['9:44', 97],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '壹中心2号楼起降点',
              rotate: 50,
              color: '#fee075',
            },
          },
        ],
        [
          {
            coord: ['9:35', 2],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '壹中心2号楼起降点',
              rotate: 50,
              color: '#56f98d',
            },
          },
          {
            coord: ['9:50', 97],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '粤秀北路1518号临时起降点',
              rotate: 50,
              color: '#fee075',
            },
          },
        ],
        [
          {
            coord: ['9:40', 2],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '壹中心2号楼起降点',
              rotate: 50,
              color: '#56f98d',
            },
          },
          {
            coord: ['9:55', 97],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '江场三路238号临时起降点',
              rotate: 50,
              color: '#fee075',
            },
          },
        ],
        [
          {
            coord: ['9:45', 2],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '江场西路395号临时起降点',
              rotate: 50,
              color: '#56f98d',
            },
          },
          {
            coord: ['10:00', 97],
            symbol: 'circle',
            symbolSize: 1,
            label: {
              show: true,
              formatter: '共和新路3201号临时起降点',
              rotate: 50,
              color: '#fee075',
            },
          },
        ]
      ],
      chartData: [
        {
          startP: '智汇园8号楼起降点2',
          startT: '9:00',
          endP: '壹中心2号楼起降点',
          endT: '9:15',
        },
        {
          startP: '智汇园8号楼起降点2',
          startT: '9:00',
          endP: '壹中心2号楼起降点',
          endT: '9:20',
        },
        {
          startP: '智汇园8号楼起降点2',
          startT: '9:10',
          endP: '壹中心2号楼起降点',
          endT: '9:25',
        },
        {
          startP: '智汇园8号楼起降点2',
          startT: '9:30',
          endP: '壹中心2号楼起降点',
          endT: '9:45',
        },
      ]
    };
  },
  computed: {
    xtop() {
      // 提取 startT 和 endT
      const startTimes = this.chartData.map(item => item.startT);
      const endTimes = this.chartData.map(item => item.endT);
      // 找到最小的 startT 和最大的 endT
      const minStartT = startTimes.reduce((min, current) => (current < min ? current : min), startTimes[0]);
      const maxEndT = endTimes.reduce((max, current) => (current > max ? current : max), endTimes[0]);
      // 将时间字符串转换为 Date 对象
      const parseTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
      };
      // 生成时间数组
        const startDate = parseTime(minStartT);
        const endDate = parseTime(maxEndT);
        const timeArray = [];
        for (let time = startDate; time <= endDate; time.setMinutes(time.getMinutes() + 5)) {
          timeArray.push(`${time.getHours()}:${time.getMinutes().toString().padStart(2, '0')}`);
        }
        return timeArray;
    }
  },
  mounted() {
    this.renderChart()
    // this.initChart();
    // this.getPlanApproved(); //获取已执行飞行活动数据
    //查询已执行数据，4秒轮询一次
    // window.queryTimer = setInterval(
    //   this.getPlanApproved,
    //   4000
    // );
  },
//   beforeDestroy() {
//     if (window.statisicsTimer) {
//       clearInterval(window.statisicsTimer);
//       window.statisicsTimer = null;
//     }
//     if (window.queryTimer) {
//       clearInterval(window.queryTimer);
//       window.queryTimer = null;
//     }
//   },
  methods: {
    // 动态生成时间轴 半小时前到当前时间
    dynamicTime() {
      // const now = new Date();
      // const currentHour = now.getHours();
      // const currentMinute = now.getMinutes();

      // 如果当前时间在9点到9点半之间，返回固定的时间数组
      // if (currentHour === 9 && currentMinute >= 0 && currentMinute <= 30) {
      // if (currentHour === 9 || (currentHour === 10 && currentMinute === 0)) {
      if (true) {

        // 航线对应的点
        this.line1 = [0, 12.5, 25, 37.5, 50, 62.5, 75, 87.5, 100];
        this.line2 = [null, null, 0, 14.285714285714286, 28.571428571428573, 42.857142857142854, 57.142857142857146, 71.42857142857143, 85.71428571428571, 100];
        this.line3 = [null, null, null, null, 0, 16.67, 33.33, 50, 66.67, 83.33, 100];


        return ['9:30', '9:31', '9:32',
          '9:33', '9:34', '9:35', '9:36', '9:37', '9:38', '9:39', '9:40', '9:41', '9:42', '9:43',
          '9:44', '9:45', '9:46', '9:47', '9:48', '9:49', '9:50', '9:51', '9:52', '9:53', '9:54',
          '9:55', '9:56', '9:57', '9:58', '9:59', '10:00',
          //  '10:01', '10:02', '10:03', '10:04',
          // '10:05', '10:06', '10:07', '10:08', '10:09', '10:10', '10:11', '10:12', '10:13', '10:14',
          // '10:15'
        ]
      }

      // // 计算半小时前的时间
      // let startHour = 0;
      // let startMinute = 0;
      // if(currentMinute < 30) {
      //     startMinute = 30 + currentMinute;
      //     startHour = currentHour - 1;
      // }else{
      //     startMinute = currentMinute - 30;
      //     startHour = currentHour;
      // }

      // // 创建起始时间
      // const startTime = new Date();
      // startTime.setHours(startHour, startMinute, 0, 0);

      // // 创建结束时间（当前时间）
      // const endTime = new Date(now);

      // // 构建时间间隔数组
      // const timeArray = [];
      // let currentTime = new Date(startTime);

      // // 设置刻度间隔为2分钟
      // while (currentTime <= endTime) {
      //     const hour = ('0' + currentTime.getHours()).slice(-2);
      //     const minute = ('0' + currentTime.getMinutes()).slice(-2);
      //     timeArray.push(hour + ':' + minute);
      //     currentTime.setMinutes(currentTime.getMinutes() + 2); // 刻度间隔为2分钟
      // }

      // return timeArray;
    },

    renderChart() {
      this.initChart()

      // const res = this.getPlanApproved().then((data) => {
      //     this.initChart()
      // }).catch((error) => {
      //     console.error(error);
      // });
    },

    initChart() {
      // 初始化echarts
      this.chart = echarts.init(this.$refs.chart);
      // 定义轴数据
      // let startTimes = this.startTime
      // let endTimes = this.endTime
      let getTime = this.dynamicTime(); //获取动态时间

      // 已执飞行数据
      let flightData = this.taskPlanCompletedList

      // 背景对应起止时间
      let markAreaStart = '9:30';
      let markAreaEnd = '10:00';
      // 获取当前日期对象
      let currentDate = new Date();

// 获取年、月、日
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1; // 月份是从 0 开始的，需要加 1
      let day = currentDate.getDate();

// 格式化月份和日期，确保是两位数
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }

// 拼接成所需格式的字符串
      let formattedDate = `${year}/${month}/${day}`;
      let titleText = '飞行活动运行图' + '（' + formattedDate + '）'

      // 配置ECharts
      let option = {
        title: {
          text: titleText,
          x: 'center',
          textStyle: {
            color: 'white',
          },
        },

        tooltip: {
          formatter: function (params) {
            return params.seriesName;
          },
        },
        xAxis: [
          {
            type: 'category',
            name: '起飞时间',
            nameLocation: 'start',
            nameTextStyle: {
              color: '#56f98d'  // 轴标题颜色
            },
            axisTick: {
              alignWithLabel:true
            },
            // data: startTimes, //起飞时间
            data: getTime, //动态设置时间
            position: 'bottom',
            axisLine: {
              lineStyle: {
                color: '#866432', // 设置x轴线颜色
                width: 2,
              }
            },
            axisLabel: {
              color: '#fff', // 坐标值颜色
            },
          },
          {
            type: 'category',
            name: '降落时间',
            nameLocation: 'start',
            nameTextStyle: {
              color: '#fee075'  // 轴标题颜色
            },
            axisTick: {
              alignWithLabel: true
            },
            // data: endTimes, //降落时间
            data: getTime,
            position: 'top',
            axisLine: {
              lineStyle: {
                color: '#866432', // 设置x轴线颜色
                width: 2,
              }
            },
            axisLabel: {
              color: '#fff', // 坐标值颜色
            },
          }
        ],
        yAxis: {
          // type: 'category',
          type: 'value',
          show: false,
          axisLine: {
            lineStyle: {
              color: '#a3cffe'
            }
          },
        },
        // series: seriesData
        // 航线
        series: [
          {
            type: 'line',
            lineStyle: {
              color: '#56f98d',
            },
            symbol: 'circle',
            symbolSize: 8,
            // showSymbol: false,
            itemStyle: {
              color: function (params) {
                if (params.value === 0) {
                  return '#56f98d';
                } else if (params.value === 100) {
                  return '#fee075';
                } else {
                  return '#56f98d';
                }
              },
              borderColor: 'rgba(255, 255, 255, 0.35)',
              borderWidth: 5,
            },
            // // 标记线
            markLine: {
              symbol: ['none', 'none'],
              lineStyle: {
                color: '#3b3129',
                type: 'solid', // 实线
              },
              label: {show: false},
              data: [
                {xAxis: 0}, {xAxis: 1}, {xAxis: 2}, {xAxis: 3}, {xAxis: 4}, {xAxis: 5}, {xAxis: 6},
                {xAxis: 7}, {xAxis: 8}, {xAxis: 9}, {xAxis: 10}, {xAxis: 11}, {xAxis: 12}, {xAxis: 13},
                {xAxis: 14}, {xAxis: 15}, {xAxis: 16}, {xAxis: 17}, {xAxis: 18}, {xAxis: 19}, {xAxis: 20},
                {xAxis: 21}, {xAxis: 22}, {xAxis: 23}, {xAxis: 24}, {xAxis: 25}, {xAxis: 26}, {xAxis: 27},
                {xAxis: 28}, {xAxis: 29}, {xAxis: 30}, {xAxis: 31}, {xAxis: 32}, {xAxis: 33}, {xAxis: 34},
                {xAxis: 35}, {xAxis: 36}, {xAxis: 37}, {xAxis: 38}, {xAxis: 39}, {xAxis: 40}, {xAxis: 41},
                {xAxis: 42}, {xAxis: 43}, {xAxis: 44}
              ], // 45根竖线
              emphasis: {
                lineStyle: {
                  width: 1,
                }
              },
            },
            // // 标记点
            markPoint: {
              data: this.markPointData[0] ,
            },
            // 标记背景颜色
            // markArea: {
            //   itemStyle: {
            //     color: 'purple',
            //   },
            //   data: [
            //     [
            //       {xAxis: markAreaStart},
            //       {xAxis: markAreaEnd},
            //     ],
            //   ]
            // },

            z: 100,
            // data: this.line1,
            data: this.lineData[0],
          },
          {
            type: 'line',
            lineStyle: {
              color: '#56f98d',
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: function (params) {
                if (params.value === 0) {
                  return '#56f98d';
                } else if (params.value === 100) {
                  return '#fee075';
                } else {
                  return '#56f98d';
                }
              },
              borderColor: 'rgba(255, 255, 255, 0.35)',
              borderWidth: 5,
            },
            // // 标记点
            markPoint: {
              data:this.markPointData[1] ,
            },
            z: 100,
            // data: this.line2,
            data: this.lineData[1],
          },
          {
            type: 'line',
            lineStyle: {
              color: '#56f98d',
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: function (params) {
                if (params.value === 0) {
                  return '#56f98d';
                } else if (params.value === 100) {
                  return '#fee075';
                } else {
                  return '#56f98d';
                }
              },
              borderColor: 'rgba(255, 255, 255, 0.35)',
              borderWidth: 5,
            },
            // // 标记点
            markPoint: {
              data: this.markPointData[2] ,
            },
            z: 100,
            // data: this.line3,
            data: this.lineData[2]
          },
          {
            type: 'line',
            lineStyle: {
              color: '#56f98d',
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: function (params) {
                if (params.value === 0) {
                  return '#56f98d';
                } else if (params.value === 100) {
                  return '#fee075';
                } else {
                  return '#56f98d';
                }
              },
              borderColor: 'rgba(255, 255, 255, 0.35)',
              borderWidth: 5,
            },
            // // 标记点
            markPoint: {
              data: this.markPointData[3] ,
            },
            z: 100,
            // data: this.line3,
            data: this.lineData[3],
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
    },
    // initChart() {
    //   this.chart = echarts.init(this.$refs.chart);
    //   const colors = ['#5470C6', '#EE6666'];
    //   let option = {
    //     color: colors,
    //     tooltip: {
    //       show: false,
    //       // trigger: 'none',
    //       // axisPointer: {
    //       //   type: 'cross'
    //       // }
    //     },
    //     legend: {
    //       show: false,
    //     },
    //     grid: {
    //       top: 70,
    //       bottom: 50
    //     },
    //     xAxis: [
    //       {
    //         type: 'category',
    //         axisTick: {
    //           alignWithLabel: true
    //         },
    //         axisLine: {
    //           onZero: false,
    //           lineStyle: {
    //             color: colors[1]
    //           }
    //         },
    //         axisPointer: {
    //           label: {
    //             formatter: function (params) {
    //               return (
    //                 'Precipitation  ' +
    //                 params.value +
    //                 (params.seriesData.length ? '：' + params.seriesData[0].data : '')
    //               );
    //             }
    //           }
    //         },
    //         // prettier-ignore
    //         data: this.xtop
    //       },
    //       {
    //         type: 'category',
    //         axisTick: {
    //           alignWithLabel: true
    //         },
    //         axisLine: {
    //           onZero: false,
    //           lineStyle: {
    //             color: colors[0]
    //           }
    //         },
    //         axisPointer: {
    //           label: {
    //             formatter: function (params) {
    //               return (
    //                 'Precipitation  ' +
    //                 params.value +
    //                 (params.seriesData.length ? '：' + params.seriesData[0].data : '')
    //               );
    //             }
    //           }
    //         },
    //         data: this.xtop
    //       }
    //     ],
    //     yAxis: [
    //       {
    //         type: 'value',
    //         show: false, // 隐藏左侧 Y 轴
    //         axisLine: {
    //           show: false // 可选：同时隐藏 Y 轴线
    //         },
    //         axisTick: {
    //           show: false // 可选：同时隐藏 Y 轴刻度
    //         }
    //       }
    //     ],
    //     series: [
    //       {
    //         name: 'Precipitation(2015)',
    //         type: 'line',
    //         xAxisIndex: 1,
    //
    //         emphasis: {
    //           focus: 'series'
    //         },
    //         data: [
    //           0,1
    //         ]
    //       },
    //       {
    //         name: 'Precipitation(2016)',
    //         type: 'line',
    //         emphasis: {
    //           focus: 'series'
    //         },
    //         data: [
    //           0,0,1
    //         ]
    //       }
    //     ]
    //   };
    //   this.chart.setOption(option);
    // },

    getPlanApproved() {
      return new Promise((resolve, reject) => {
        this.getRequest("/uav-task-server/plandto/queryPlanDtoByCondition")
          .then((res) => {
            let oData = res.data;
            let planData = oData.data;
            let taskPlanCompletedList = [];
            for (let i = 0, len = planData.length; i < len; i++) {
              if (planData[i].status === 3 || planData[i].status === 4) {
                taskPlanCompletedList.push(planData[i]);
                this.itemCompletedList.push(planData[i].id);
              }
            }
            this.taskPlanCompletedList = taskPlanCompletedList;
            this.startTime = [...new Set(taskPlanCompletedList.map(item => item.startTime))];
            this.endTime = [...new Set(taskPlanCompletedList.map(item => item.endTime))];
            this.airpointList = taskPlanCompletedList.map(item => item.airpointList)
            this.startPoint = [...new Set(taskPlanCompletedList.map(item => item.startPoint))];
            this.endPoint = [...new Set(taskPlanCompletedList.map(item => item.endPoint))];
            // this.altitude = [...new Set(taskPlanCompletedList.flatMap(item => item.airpointList.map(point => point.altitude)))].sort();

            console.log('-->', this.taskPlanCompletedList)
            // console.log('已执行飞行-->', taskPlanCompletedList);
            resolve(taskPlanCompletedList);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // getPlanApproved(){
    //     this.getRequest(
    //             "/uav-task-server/plandto/queryPlanDtoByCondition"
    //         ).then((res) => {
    //             let oData = res.data;
    //             let planData = oData.data;
    //             let taskPlanCompletedList = [];
    //             for (let i = 0, len = planData.length; i < len; i++)
    //             {
    //                 if ((3 === planData[i].status|4 === planData[i].status)) {
    //                 taskPlanCompletedList.push(planData[i]);
    //                 }
    //             }
    //             this.taskPlanCompletedList = taskPlanCompletedList;
    //             this.startTime = taskPlanCompletedList.map(item => item.startTime)
    //             console.log('已执行-->', taskPlanCompletedList)
    //             console.log('时间-->', this.startTime)
    //         });
    //     },


  },
};
</script>

<style scoped>
#container {
  margin: 15px 40px 20px;
}

#container .content {
  /* background: rgba(16,22,52,0.2);
  border: 2px solid #192b49;
  border-radius: 2px; */
  background: url(../../assets/img/common/biankuang.png) center no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
}

#container .title {
  width: 346px;
  height: 32px;
  background: url(../../assets/img/common/tableHead1.png) center no-repeat;
}

#container .title .titleTxt {
  padding-left: 15px;
  color: #fff;
  font-size: 18px;
  line-height: 35px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: start;
}

#container .content .chart-container {
  padding: 20px;
}


/* echart */
.chart-container {
  width: 100%;
  height: calc(100vh - 225px);
}

.echarts-chart {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/home/FlightDataShow.vue